import React, { FC, useContext } from 'react';
import { UseFieldArrayAppend } from 'react-hook-form';

import { AttachmentGroups } from '@buyside/components/presentation/WhitePaperForm/WriteupAndAttachments/writeupAndAttachments';
import { WhitePaperFormContext } from '@buyside/components/presentation/WhitePaperForm/whitePaperForm';
import ElevatorPitchField from '@buyside/components/presentation/ResearchFormWizard/SharedFields/elevatorPitchField';
import ResearchFormWizardSection from '@buyside/components/presentation/ResearchFormWizard/researchFormWizardSection';
import MentionedEntitiesField from '@buyside/components/presentation/ResearchFormWizard/SharedFields/mentionedEntitiesField';
import TagListField from '@buyside/components/presentation/ResearchFormWizard/SharedFields/tagListField';
import ThesisField from '@buyside/components/presentation/ResearchFormWizard/SharedFields/thesisField';
import ThesisTypeSelection from '@buyside/components/presentation/WhitePaperForm/WriteupAndAttachments/Writeup/thesisTypeSelection';

import { WhitePaperFormInput } from '@buyside/util/researchSubmission';

import styles from './writeupStyles.scss';

const Writeup: FC<{
  append: UseFieldArrayAppend<WhitePaperFormInput, 'attachments'>;
  handleRemoveThesisAttachment: () => void;
  setThesisEditorHidden: (hidden: boolean) => void;
  thesisAttachmentGroup: AttachmentGroups['thesis'];
  thesisEditorHidden: boolean;
}> = ({
  append,
  handleRemoveThesisAttachment,
  setThesisEditorHidden,
  thesisAttachmentGroup,
  thesisEditorHidden
}) => {
  const { whitePaperId } = useContext(WhitePaperFormContext);

  if (!whitePaperId) throw new Error();

  return (
    <ResearchFormWizardSection title="Writeup">
      <div className={styles.gridLayout}>
        <ElevatorPitchField />
      </div>
      {thesisEditorHidden ? (
        <ThesisTypeSelection
          append={append}
          handleRemoveThesisAttachment={handleRemoveThesisAttachment}
          setThesisEditorHidden={setThesisEditorHidden}
          thesisAttachmentGroup={thesisAttachmentGroup}
        />
      ) : (
        <ThesisField
          imageableId={whitePaperId}
          imageableType="WhitePaper"
          onAttachThesisInstead={() => setThesisEditorHidden(true)}
        />
      )}
      <div className={styles.gridLayout}>
        <TagListField />
        <MentionedEntitiesField />
      </div>
    </ResearchFormWizardSection>
  );
};

export default Writeup;
